import React, { FC } from "react";
import AdminMainNav from "./MainNav2Logged";

export interface HeaderProps {}

const Header: FC<HeaderProps> = () => {
  return (
    <div className="nc-Header relative w-full z-40 ">
      <AdminMainNav />
    </div>
  );
};

export default Header;
